






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Button extends Vue {
  @Prop(Boolean)
  primary!: boolean;

  click(event: any) {
    this.$emit('click', event);
  }
}
